import './ClaimStatusText.scss';

const GenerateClaimStatus = ({ claim }) => {
    let txt = "בטיפול";
    let icon = 4;
    let color = "#5A6DED";
    let colorText = "blue";

    switch (claim.status * 1) {
        case -1:
            txt = "";
            break;
        case 0:
            txt = "נפתחה";
            break;
        case 1:
            txt = "ממתינה למסמכי לקוח";
            color = "#FEB103";
            colorText = "orange";
            break;
        case 2:
            txt = "מסמכים רפואיים בבדיקה";
            break;
        case 3:
            txt = "בטיפול מחלקת תביעות";
            break;
        case 4:
            txt = "בטיפול מחלקת תביעות";
            break;
        case 5:
            txt = "בחינת חברת הביטוח";
            break;
        case 15:
            txt = "אושרה";
            color = "#7DCA78";
            colorText = "green";
            break;
        case 20:
            txt = "לא אושרה";
            color = "#AEAEAE";
            colorText = "gray";
            break;
        case 21:
            txt = "סגירה טכנית";
            color = "#AEAEAE";
            colorText = "gray";
            break;
    }

    return { txt, icon, color, colorText };
}

const ClaimStatusLabel = ({ claim }) => {
    let status = GenerateClaimStatus({ claim });

    return (<div className={`claim-status-label`} style={{ backgroundColor: status.color }}><img src="/img/claim-icon-finished.svg" alt="" /><span>{status.txt}</span></div>);
};

export { ClaimStatusLabel, GenerateClaimStatus };